import Header from "./components/Header";
import StitchCalculator from "./components/StitchCalculator";

function App(): JSX.Element {
  return (
    <div className="container">
      <Header />
      <StitchCalculator />
    </div>
  );
}

export default App;
